import { Box, Button, Checkbox, CircularProgress, Container, FormControlLabel, Grid, ImageList, ImageListItem, ImageListItemBar, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TablePagination, TableRow } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';
import { saveAs } from 'file-saver';
import { Redirect } from 'react-router-dom';
import { PDFDownloadLink, Document, Page, Text } from '@react-pdf/renderer';
import InformesReglamentaria from '../InformesPDF/InformesReglamentaria';
import InformesEnfermedad from '../InformesPDF/InformeEnfermedad';
import ComplementoAntiguedad from '../InformesPDF/ComplementoAntiguedad';
import GeneralPDF from '../InformesPDF/GeneralPDF';


const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const handleDownloadPdf = (name, data) => {
    const blobData = atob(data);
    const byteArray = new Uint8Array(blobData.length);
    for (let i = 0; i < blobData.length; i++) {
      byteArray[i] = blobData.charCodeAt(i);
    }
    const fileBlob = new Blob([byteArray], { type: 'application/pdf' });
    const fileUrl = URL.createObjectURL(fileBlob);

    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};


let desc = '';
let entradaIn = '';
let salidaIn = '';
let entradaLunes = '';

const opcionesFilasPorPagina = [5, 10, 25, 50, 100];
let filasTotales = 0;
class Informes extends Component {
    constructor(props){
        super(props);
        this.state = {

            //------------------
            pagina: 0,
            filasPorPagina: 5,
            //------------------

            notificaciones: null,
            errores: null,
            consulta: false,
            codigosInforme: [],
            codigosInformeSV: [],
            numeroNombre: [],
            lugaresTra: [],
            ubicacionesCentral: [],
            modalRechazar: false,
            archivo: '',
            archivoActa: '',
            datoPDF: {
                numeroFuncionario: '',
                anio: '',
                codigo: '',
                desde: '',
                hasta: '',
                solicitado: '',
                dias: '',
                nombreFuncionario: '',
                titulo: '',
                firmaFuncionario: '',
                firmaJefe: '',
                archivo: '',
                complemento: '',
                archivoActa: '',
            },
            datosConsulta: {
                tipoUsuario: sessionStorage.tipoUsuario,
                tipoMov: '1',
            },

            //-----------------------------------
            movimientos: {
                numeroFuncionario: '',
                codigo: '',
                nombreFuncionario: '',
                dias: '0',
                minutos: '0',
                desde: '',
                hasta: '',
                anio: '',
                tipoMov: '1',
                tipoHS: '',
                tipoConsulta: '',
            },
            //-----------------------------------
            datoModal: {
                numeroFuncionario: '',
                nombreFuncionario: '',
                motivoRechazo: '',
                tipoUsuario: sessionStorage.tipoUsuario,
            },

            busqueda: {
                informe: '',
                numeroFuncionarioBusqueda: '',
                nombreFuncionarioBusqueda: '',
                ubicacionBusqueda: '',
                ubicacionCentral: '',
                desdeBusqueda: '',
                hastaBusqueda: '',
                tipoUsuario: sessionStorage.tipoUsuario,
                anio: '',
                dias: '',
                minutos: '',
                salida: '',
                entrada: '',
            },

            datoEspecifico: {},

            //Informes para PDF
            reglamentariaPDF: false,
            enfermedadPDF: false,
            complementoPDF: false,
            general: false,
            loading: false,
            consultaEspecifica: false,
            imagenMostrar: '',
            imagenMostrarModal: false,

            horasEntradas: [],
            continua: false,


        }
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejoEnvioConsulta = this.manejoEnvioConsulta.bind(this);
        this.manejarAceptar = this.manejarAceptar.bind(this);
        this.manejarRechazar = this.manejarRechazar.bind(this);
        this.actList = this.actList.bind(this);
        this.manejarCambioRechazo = this.manejarCambioRechazo.bind(this);
        this.manejarEnvioRechazo = this.manejarEnvioRechazo.bind(this);
        this.manejarAtras = this.manejarAtras.bind(this);
        this.manejarCambiosDatosArchivo = this.manejarCambiosDatosArchivo.bind(this);
        this.cerrarModal = this.cerrarModal.bind(this);
        this.manejarConsultaInforme = this.manejarConsultaInforme.bind(this);
        this.manejarAtrasEspecifica = this.manejarAtrasEspecifica.bind(this);
        this.manejarModalImagen = this.manejarModalImagen.bind(this);
        this.manejarCerrarModal = this.manejarCerrarModal.bind(this);
        this.manejarCambiosContinua = this.manejarCambiosContinua.bind(this);
    }

    async componentDidMount(){
        const fech = new Date();
        this.setState(state => {
            const numFunActualizado = state.busqueda;
            numFunActualizado['hastaBusqueda'] = fech.toISOString().substring(0,10);
            numFunActualizado['desdeBusqueda'] = fech.toISOString().substring(0,10);
            return{
                busqueda: numFunActualizado,
            };
        });

        if(sessionStorage.login && ((sessionStorage.tipoUsuario === '4') || (sessionStorage.tipoUsuario === '5'))){
            const codInfo = await fetch(`${Constantes.RUTA_API}/obtener_codigosInformesPersonal.php`);
            const datosCodInfo = await codInfo.json();
            this.setState({
                codigosInforme: datosCodInfo,
            });
        }else if(sessionStorage.login && (sessionStorage.tipoUsuario === '6')){
            this.setState({
                codigosInforme: [
                    {
                        idCodigosInformesPersonal: 2,
                        descripcion: 'ANTIGÜEDAD',
                    },
                    {
                        idCodigosInformesPersonal: 1,
                        descripcion: 'REGLAMENTARIA',
                    },
                    {
                        idCodigosInformesPersonal: 57,
                        descripcion: 'LICENCIA EXTRAORDINARIA COVID',
                    },
                ]
            })
        }

        const numNom = await fetch(`${Constantes.RUTA_API}/obtener_numerosNombre.php`);
        const datosNumNom = await numNom.json();
        this.setState({
            numeroNombre: datosNumNom,
        });

        const lugar = await fetch(`${Constantes.RUTA_API}/obtener_lugaresTrabajo.php`);
        const datoLugar = await lugar.json();
        this.setState({
            lugaresTra: datoLugar,
        });


        const lugarCentral = await fetch(`${Constantes.RUTA_API}/obtener_ubicacionesCentral.php`);
        const datoLugarCentral = await lugarCentral.json();
        this.setState({
            ubicacionesCentral: datoLugarCentral,
        });

        const ent = await fetch(`${Constantes.RUTA_API}/obtener_entradas.php`);
        const datosEntrada = await ent.json();
        this.setState({
            horasEntradas: datosEntrada,
        });
    }

    handleChangePage = (event, nuevaPagina) => {
        this.setState({ pagina: nuevaPagina });
    };
    
    handleChangeRowsPerPage = (event) => {
        const filasPorPagina = event.target.value === 'all' ? this.state.datosConsulta.length : parseInt(event.target.value, 10);
        this.setState({ filasPorPagina, pagina: 0 });
    };


    render(){
        const { pagina, filasPorPagina } = this.state;
        filasTotales = this.state.datosConsulta.length;
        return (
            <>
                {sessionStorage.login && (sessionStorage.tipoUsuario === '4' || sessionStorage.tipoUsuario === '5' || sessionStorage.tipoUsuario === '6')
                ?
                    !this.state.consultaEspecifica
                    ?
                        <Container>
                            {this.state.loading
                            ?
                                <div style={{placeItems: 'center'}}>
                                    <Box sx={{alignItems: 'center'}}>
                                        <CircularProgress/>
                                    </Box>
                                </div>
                            :
                                null
                            }
                            <h3>Informes</h3>
                            {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                            {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                            <br/>
                            <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper} >
                            {this.state.consulta
                            ?
                                <>
                                    <Table sx={{minWidth: 700}} id="tablaConsulta">
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell>Informe</StyledTableCell>
                                                <StyledTableCell>Año</StyledTableCell>
                                                <StyledTableCell>Número</StyledTableCell>
                                                <StyledTableCell>Nombre</StyledTableCell>
                                                <StyledTableCell>Desde</StyledTableCell>
                                                <StyledTableCell>Hasta</StyledTableCell>
                                                <StyledTableCell></StyledTableCell>
                                                <StyledTableCell></StyledTableCell>
                                                <StyledTableCell></StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                        {this.state.datosConsulta.slice(this.state.pagina * this.state.filasPorPagina, this.state.pagina * this.state.filasPorPagina + this.state.filasPorPagina).map((name) => (
                                            <StyledTableRow key={name.idInformes}>
                                                {this.state.codigosInforme.map((name2) => {
                                                    if(name2.idCodigosInformesPersonal === name.codigo){
                                                        desc = name2.descripcion;
                                                    }
                                                })}
                                                
                                                {((name.codigo === 5 || name.codigo === 52) && name.finalizado === 12) ? <StyledTableCell style={{color: 'red'}}>{desc} Enviado por Certificado</StyledTableCell> : <StyledTableCell>{desc}</StyledTableCell>}
                                                <StyledTableCell>{name.anio}</StyledTableCell>
                                                <StyledTableCell>{name.numeroFuncionario}</StyledTableCell>
                                                <StyledTableCell>{name.nombreFuncionario}</StyledTableCell>
                                                <StyledTableCell>{name.desde.substring(8,10) + '/' + name.desde.substring(5,7) + '/' + name.desde.substring(0,4)}</StyledTableCell>
                                                {name.hasta === null || name.hasta.substring(8,10) === '00' ? <StyledTableCell></StyledTableCell> : <StyledTableCell>{name.hasta.substring(8,10) + '/' + name.hasta.substring(5,7) + '/' + name.hasta.substring(0,4)}</StyledTableCell>}
                                                <StyledTableCell><button className="btn btn-outline-primary mx-2" type='button' onClick={() => this.manejarAceptar(name)}>Aceptar</button></StyledTableCell>
                                                <StyledTableCell><button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarRechazar(name)}>Rechazar</button></StyledTableCell>
                                                <StyledTableCell><button className="btn btn-outline-success mx-2" type='button' onClick={() => this.manejarConsultaInforme(name)}>Consultar</button></StyledTableCell>
                                            </StyledTableRow>
                                        ))}
                                        </TableBody>
                                    </Table>
                                    <TablePagination rowsPerPageOptions={opcionesFilasPorPagina} component="div" count={filasTotales} rowsPerPage={this.state.filasPorPagina} page={this.state.pagina} onPageChange={this.handleChangePage} onRowsPerPageChange={this.handleChangeRowsPerPage} labelRowsPerPage="Filas por página" SelectProps={{inputProps: {'aria-label': 'Filas por página',}, displayEmpty: true,}}/>
                                </>
                            : 
                                <Table sx={{minWidth: 700}} id="tablaConsulta">
                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell>Informe</StyledTableCell>
                                            <StyledTableCell>Número</StyledTableCell>
                                            <StyledTableCell>Nombre</StyledTableCell>
                                            {(this.state.busqueda.tipoUsuario === '4') && ((this.state.busqueda.informe === '3') || (this.state.busqueda.informe === '3') || (this.state.busqueda.informe === '7') || (this.state.busqueda.informe === '16') || (this.state.busqueda.informe === '17') || (this.state.busqueda.informe === '8')) ? null : <StyledTableCell>Departamento</StyledTableCell>}
                                            {this.state.busqueda.ubicacionBusqueda === '0' ? <StyledTableCell>Central</StyledTableCell> : null}
                                            {((this.state.busqueda.informe === '16') || (this.state.busqueda.informe === '17') || (this.state.busqueda.informe === '8')) && sessionStorage.tipoUsuario === '4' ? <StyledTableCell>Días</StyledTableCell> : null }
                                            {((this.state.busqueda.informe === '3') || (this.state.busqueda.informe === '16') || (this.state.busqueda.informe === '17') || (this.state.busqueda.informe === '7') || (this.state.busqueda.informe === '8')) && sessionStorage.tipoUsuario === '4' ? <StyledTableCell>Desde</StyledTableCell> : null }
                                            {((this.state.busqueda.informe === '3') || (this.state.busqueda.informe === '16') || (this.state.busqueda.informe === '17') || (this.state.busqueda.informe === '7')) && sessionStorage.tipoUsuario === '4' ? <StyledTableCell>Hasta</StyledTableCell> : null }
                                            {((this.state.busqueda.informe === '3') && sessionStorage.tipoUsuario === '4') ? <StyledTableCell>Continua</StyledTableCell> : null}
                                            {((this.state.busqueda.informe === '3')&& (sessionStorage.tipoUsuario === '4') && (!this.state.continua)) ? <StyledTableCell>Imagen BPS</StyledTableCell> : null}
                                            {((this.state.busqueda.informe === '7') || (this.state.busqueda.informe === '8')) && sessionStorage.tipoUsuario === '4' ? <StyledTableCell>Imagen BPS</StyledTableCell> : null }
                                            {((this.state.busqueda.informe === '8')) && sessionStorage.tipoUsuario === '4' ? <StyledTableCell>Acta de Nacimiento</StyledTableCell> : null }
                                            <StyledTableCell></StyledTableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <StyledTableRow>
                                            <StyledTableCell>
                                                <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='informe'  value={this.state.busqueda.informe} onChange={this.manejarCambiosDatos}>
                                                    <option value=''>INFORMES</option>
                                                    <option value='10000' key={'10000'}>TODAS LAS SOLICITUDES</option>
                                                    {this.state.codigosInforme.map((name) =>
                                                        <option
                                                        key={name.idCodigosInformesPersonal}
                                                        value={name.idCodigosInformesPersonal}
                                                        >{name.descripcion}</option>
                                                        )}
                                                </select>
                                            </StyledTableCell>
                                            <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='numeroFuncionarioBusqueda' value={this.state.busqueda.numeroFuncionarioBusqueda} onChange={this.manejarCambiosDatos}/></StyledTableCell>
                                            <StyledTableCell>{this.state.busqueda.nombreFuncionarioBusqueda}</StyledTableCell>
                                            {(this.state.busqueda.tipoUsuario === '4') && ((this.state.busqueda.informe === '3') || (this.state.busqueda.informe === '3') || (this.state.busqueda.informe === '7') || (this.state.busqueda.informe === '16') || (this.state.busqueda.informe === '17') || (this.state.busqueda.informe === '8'))
                                            ?
                                                null
                                            :
                                                <StyledTableCell>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='ubicacionBusqueda'  value={this.state.busqueda.ubicacionBusqueda} onChange={this.manejarCambiosDatos}>
                                                        <option value=''>UBICACION</option>
                                                        {this.state.lugaresTra.map((name) =>
                                                            <option
                                                            key={name.idLugaresTrabajo}
                                                            value={name.idLugaresTrabajo}
                                                            >{name.lugar}</option>
                                                            )}
                                                    </select>
                                                </StyledTableCell>
                                            }
                                            {this.state.busqueda.ubicacionBusqueda === '0'
                                            ?
                                                <StyledTableCell>
                                                    <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='ubicacionCentral'  value={this.state.busqueda.ubicacionCentral} onChange={this.manejarCambiosDatos}>
                                                        <option value=''>UBICACION</option>
                                                        {this.state.ubicacionesCentral.map((name) =>            
                                                            <option
                                                            key={name.idUbicacionesCentral}
                                                            value={name.idUbicacionesCentral}
                                                            >{name.descripcion}
                                                        </option>
                                                            )}
                                                    </select>
                                                </StyledTableCell>
                                            :
                                                null
                                            }
                                            {((this.state.busqueda.informe === '16') || (this.state.busqueda.informe === '17') || (this.state.busqueda.informe === '8')) && sessionStorage.tipoUsuario === '4' ? <StyledTableCell><input style={{width:"100%", border:"2px solid #D6EAF8"}} type="number" id='dias' value={this.state.busqueda.dias} onChange={this.manejarCambiosDatos}/></StyledTableCell> : null}
                                            {((this.state.busqueda.informe === '3') || (this.state.busqueda.informe === '16') || (this.state.busqueda.informe === '17') || (this.state.busqueda.informe === '7') || (this.state.busqueda.informe === '8')) && sessionStorage.tipoUsuario === '4' ? <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='desdeBusqueda' value={this.state.busqueda.desdeBusqueda} onChange={this.manejarCambiosDatos}/></StyledTableCell> : null}
                                            {((this.state.busqueda.informe === '3') || (this.state.busqueda.informe === '16') || (this.state.busqueda.informe === '17') || (this.state.busqueda.informe === '7')) && sessionStorage.tipoUsuario === '4' ? <StyledTableCell><input min={'1000-01-01'} max={'9999-12-31'} style={{width:"100%", border:"2px solid #D6EAF8"}} type="date" id='hastaBusqueda' value={this.state.busqueda.hastaBusqueda} onChange={this.manejarCambiosDatos}/></StyledTableCell> : null}
                                            {((this.state.busqueda.informe === '3') && sessionStorage.tipoUsuario === '4') ? <StyledTableCell><FormControlLabel label='' control={<Checkbox checked={this.state.continua} onChange={this.manejarCambiosContinua} id='add'  inputProps={{ 'aria-label': 'controlled' }} />}/></StyledTableCell> : null}
                                            {((this.state.busqueda.informe === '3') && (sessionStorage.tipoUsuario === '4') && (!this.state.continua)) ? <StyledTableCell><input type='file' id='archivo' onChange={this.manejarCambiosDatosArchivo}></input></StyledTableCell> : null}
                                            {((this.state.busqueda.informe === '7') || (this.state.busqueda.informe === '8')) && sessionStorage.tipoUsuario === '4' ? <StyledTableCell><input type='file' id='archivo' onChange={this.manejarCambiosDatosArchivo}></input></StyledTableCell> : null}
                                            {((this.state.busqueda.informe === '8')) && sessionStorage.tipoUsuario === '4' ? <StyledTableCell><input type='file' id='archivoActa' onChange={this.manejarCambiosDatosArchivo}></input></StyledTableCell> : null}
                                            <StyledTableCell><button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejoEnvioConsulta()}>Confirmar</button></StyledTableCell>
                                        </StyledTableRow>
                                    </TableBody>
                                </Table>
                            }
                            </TableContainer>
                            {this.state.consulta
                            ?
                                <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtras}>Volver</button>
                            :
                                null
                            }
                        </Container>
                    :
                        null
                :
                    <Redirect to='/login'/>
                }
                {sessionStorage.login && (sessionStorage.tipoUsuario === '4' || sessionStorage.tipoUsuario === '5' || sessionStorage.tipoUsuario === '6')
                ?
                    <Modal open={this.state.modalRechazar}>
                        <form className='formulario1'>
                            <Box sx={styleModal} >
                                <h3 style={{textAlign:'center'}}>Rechazar Informe</h3>
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={6}>
                                        <Item>Número de Funcionario</Item>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Item>{this.state.datoModal.numeroFuncionario}</Item>
                                    </Grid>
                                    <Grid item xs={2}>

                                    </Grid>
                                    <Grid item xs={6}>
                                        <Item>Nombre de Funcionario</Item>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Item>{this.state.datoModal.nombreFuncionario}</Item>
                                    </Grid>
                                    <Grid item xs={2}>

                                    </Grid>
                                    <Grid item xs={6}>
                                        <Item>Motivo del Rechazo</Item>
                                    </Grid>
                                    <Grid item xs={4}>
                                        
                                    </Grid>
                                    <Grid item xs={2}>

                                    </Grid>
                                    <Grid item xs={12}>
                                        <Item><input style={{border: "2px solid #D6EAF8", width: "100%"}} id='motivoRechazo' type='text' onChange={this.manejarCambioRechazo}></input></Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        
                                    </Grid>
                                    <Grid item xs={4}>
                                        <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioRechazo}>Confirmar</button>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Cancelar</button>
                                    </Grid>
                                </Grid>
                            </Box>
                        </form>
                    </Modal>
                :
                    <Redirect to='/login'/>
                }
                {this.state.consultaEspecifica
                ?
                    <Container>
                        <h3>Informes</h3>
                        <Box sx={{ flexGrow: 1}}>
                            <Grid container spacing={2} rowSpacing={1}>
                                {this.state.codigosInforme.map((name2) => {
                                    if(name2.idCodigosInformesPersonal === this.state.datoEspecifico.codigo){
                                        desc = name2.descripcion;
                                    }
                                })}
                                <Grid item xs={4}>
                                </Grid>
                                <Grid item xs={4}>
                                    <h4>{desc}</h4>
                                </Grid>
                                <Grid item xs={4}>
                                </Grid>
                                <Grid item xs={4}>
                                </Grid>
                                <Grid item xs={4}>
                                    <h5>{this.state.datoEspecifico.nombreFuncionario}</h5>
                                </Grid>
                                <Grid item xs={4}>
                                </Grid>
                                {/*Esto va siempre */}
                                <Grid item xs={2}>
                                </Grid>
                                {this.state.datoEspecifico.codigo === 3 || this.state.datoEspecifico.codigo === 4 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 43 || this.state.datoEspecifico.codigo === 77 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 19 || this.state.datoEspecifico.codigo === 21 || this.state.datoEspecifico.codigo === 44 || this.state.datoEspecifico.codigo === 51 || this.state.datoEspecifico.codigo === 22 || this.state.datoEspecifico.codigo === 23 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 47 || this.state.datoEspecifico.codigo === 48 || this.state.datoEspecifico.codigo === 56 || this.state.datoEspecifico.codigo === 66
                                ?
                                    <Grid item xs={2}>
                                        <Item>Certificado (Imagen)</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 75
                                ?
                                    <Grid item xs={2}>
                                        <Item>Comprobante (Imagen)</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 10
                                ?
                                    <Grid item xs={2}>
                                        <Item>Constancia de Domicilio</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 75
                                ?
                                    this.state.datoEspecifico.esPDF
                                    ?
                                        <Grid item xs={2}>
                                            <button className="btn btn-outline-primary mx-2" onClick={() => handleDownloadPdf('archivo.pdf', this.state.datoEspecifico.archivoBPS)}>Descargar</button>
                                        </Grid>
                                    :
                                        <Grid item xs={2}>
                                            <button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModalImagen(this.state.datoEspecifico.archivoBPS)}>Ver</button>
                                        </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 3 || this.state.datoEspecifico.codigo === 22 || this.state.datoEspecifico.codigo === 51 || this.state.datoEspecifico.codigo === 10 || this.state.datoEspecifico.codigo === 19 || this.state.datoEspecifico.codigo === 23 || this.state.datoEspecifico.codigo === 48 || this.state.datoEspecifico.codigo === 43 || this.state.datoEspecifico.codigo === 4 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 47 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 56 || this.state.datoEspecifico.codigo === 77 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 66 || this.state.datoEspecifico.codigo === 21
                                ?
                                    this.state.datoEspecifico.esPDF
                                    ?
                                        <Grid item xs={2}>
                                            <button className="btn btn-outline-primary mx-2" onClick={() => handleDownloadPdf('archivo.pdf', this.state.datoEspecifico.archivoBPS)}>Descargar</button>
                                        </Grid>
                                    :
                                        <Grid item xs={2}>
                                            <button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModalImagen(this.state.datoEspecifico.archivoBPS)}>Ver</button>
                                        </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 4 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 43 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 77 || this.state.datoEspecifico.codigo === 19 || this.state.datoEspecifico.codigo === 10 || this.state.datoEspecifico.codigo === 21 || this.state.datoEspecifico.codigo === 44 || this.state.datoEspecifico.codigo === 51 || this.state.datoEspecifico.codigo === 22 || this.state.datoEspecifico.codigo === 23 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 47 || this.state.datoEspecifico.codigo === 48 || this.state.datoEspecifico.codigo === 56 || this.state.datoEspecifico.codigo === 66
                                ?
                                    <Grid item xs={1}>

                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13
                                ?
                                    <Grid item xs={2}>
                                        <Item>Certificado De Parentesco (Imagen)</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 11
                                ?
                                    this.state.datoEspecifico.esPDF
                                    ?
                                        <Grid item xs={2}>
                                            <button className="btn btn-outline-primary mx-2" onClick={() => handleDownloadPdf('archivo.pdf', this.state.datoEspecifico.archivoActa)}>Descargar</button>
                                        </Grid>
                                    :
                                        <Grid item xs={2}>
                                            <button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModalImagen(this.state.datoEspecifico.archivoActa)}>Ver</button>
                                        </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13
                                ?
                                    <Grid item xs={1}>

                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13
                                ?
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 4 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13
                                ?
                                    <Grid item xs={2}>
                                        <Item>Familiar</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13 || this.state.datoEspecifico.codigo === 4
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.familiar}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 4 || this.state.datoEspecifico.codigo === 42 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13
                                ?
                                    <Grid item xs={1}>

                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 4|| this.state.datoEspecifico.codigo === 42
                                ?
                                    <Grid item xs={2}>

                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 74 && this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 60
                                ?
                                    <Grid item xs={2}>
                                        <Item>{this.state.datoEspecifico.codigo === 43 || this.state.datoEspecifico.codigo === 19 || this.state.datoEspecifico.codigo === 10 || this.state.datoEspecifico.codigo === 21 || this.state.datoEspecifico.codigo === 106 || this.state.datoEspecifico.codigo === 109 || this.state.datoEspecifico.codigo === 77 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 110 || this.state.datoEspecifico.codigo === 62 || this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 53 ? 'Día' : 'Desde'}</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 61 && this.state.datoEspecifico.codigo !== 74 && this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 60
                                ?
                                    <Grid item xs={2}>
                                        {String(this.state.datoEspecifico.desde).substring(8,10) + '/' + String(this.state.datoEspecifico.desde).substring(5,7) + '/' + String(this.state.datoEspecifico.desde).substring(0,4)}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 61
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.marca1}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 30
                                ?
                                    <Grid item xs={1}>

                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 56 || this.state.datoEspecifico.codigo === 77
                                ?
                                    <Grid item xs={2}>

                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 3 || this.state.datoEspecifico.codigo === 22 || this.state.datoEspecifico.codigo === 51 || this.state.datoEspecifico.codigo === 23 || this.state.datoEspecifico.codigo === 48 || this.state.datoEspecifico.codigo === 11 || this.state.datoEspecifico.codigo === 47 || this.state.datoEspecifico.codigo === 66 || this.state.datoEspecifico.codigo === 12 || this.state.datoEspecifico.codigo === 13
                                ?
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo !== 53 && this.state.datoEspecifico.codigo !== 30 && this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 62 && this.state.datoEspecifico.codigo !== 74 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 37 && this.state.datoEspecifico.codigo !== 77
                                ?
                                    <Grid item xs={2}>
                                        <Item>Hasta</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo !== 53 && this.state.datoEspecifico.codigo !== 30 && this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 62 && this.state.datoEspecifico.codigo !== 74 && this.state.datoEspecifico.codigo !== 61 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 37 && this.state.datoEspecifico.codigo !== 77
                                ?
                                    <Grid item xs={2}>
                                        {String(this.state.datoEspecifico.hasta).substring(8,10) + '/' + String(this.state.datoEspecifico.hasta).substring(5,7) + '/' + String(this.state.datoEspecifico.hasta).substring(0,4)}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 61
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.marca2}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo !== 53 && this.state.datoEspecifico.codigo !== 30 && this.state.datoEspecifico.codigo !== 3 && this.state.datoEspecifico.codigo !== 62 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 37 && this.state.datoEspecifico.codigo !== 77
                                ?
                                <Grid item xs={1}>

                                </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 61
                                ?
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 61 || this.state.datoEspecifico.codigo === 60
                                ?
                                    <Grid item xs={2}>
                                        <Item>Día</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 61 || this.state.datoEspecifico.codigo === 60
                                ?
                                    <Grid item xs={2}>
                                        {String(this.state.datoEspecifico.desde).substring(8,10) + '/' + String(this.state.datoEspecifico.desde).substring(5,7) + '/' + String(this.state.datoEspecifico.desde).substring(0,4)}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 80 || this.state.datoEspecifico.codigo === 71 || this.state.datoEspecifico.codigo === 1 || this.state.datoEspecifico.codigo === 67 || this.state.datoEspecifico.codigo === 40 || this.state.datoEspecifico.codigo === 16 || this.state.datoEspecifico.codigo === 17 || this.state.datoEspecifico.codigo === 29 || this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 52 || this.state.datoEspecifico.codigo === 14 || this.state.datoEspecifico.codigo === 15 || this.state.datoEspecifico.codigo === 20
                                ?
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo !== 53 && this.state.datoEspecifico.codigo !== 30 && this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 62 && this.state.datoEspecifico.codigo !== 74 && this.state.datoEspecifico.codigo !== 61 && this.state.datoEspecifico.codigo !== 4 && this.state.datoEspecifico.codigo !== 46 && this.state.datoEspecifico.codigo !== 28 && this.state.datoEspecifico.codigo !== 42 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 44 && this.state.datoEspecifico.codigo !== 11 && this.state.datoEspecifico.codigo !== 12 && this.state.datoEspecifico.codigo !== 13 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 47 && this.state.datoEspecifico.codigo !== 66
                                ?    
                                    <Grid item xs={2}>
                                        <Item>Días</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo !== 53 && this.state.datoEspecifico.codigo !== 30 && this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 62 && this.state.datoEspecifico.codigo !== 74 && this.state.datoEspecifico.codigo !== 61 && this.state.datoEspecifico.codigo !== 4 && this.state.datoEspecifico.codigo !== 46 && this.state.datoEspecifico.codigo !== 28 && this.state.datoEspecifico.codigo !== 42 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 44 && this.state.datoEspecifico.codigo !== 11 && this.state.datoEspecifico.codigo !== 12 && this.state.datoEspecifico.codigo !== 13 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 47 && this.state.datoEspecifico.codigo !== 66
                                ?  
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.dias}
                                    </Grid>
                                :
                                    null
                                }
                                {(this.state.datoEspecifico.codigo === 52) || (this.state.datoEspecifico.codigo === 5) || (this.state.datoEspecifico.codigo === 80) || (this.state.datoEspecifico.codigo === 71) || (this.state.datoEspecifico.codigo === 1) || (this.state.datoEspecifico.codigo === 67) || (this.state.datoEspecifico.codigo === 2) || (this.state.datoEspecifico.codigo === 77) || (this.state.datoEspecifico.codigo === 37) || (this.state.datoEspecifico.codigo === 40) || (this.state.datoEspecifico.codigo === 35) || (this.state.datoEspecifico.codigo === 56) || (this.state.datoEspecifico.codigo === 14) || (this.state.datoEspecifico.codigo === 15) || (this.state.datoEspecifico.codigo === 16) || (this.state.datoEspecifico.codigo === 17) || (this.state.datoEspecifico.codigo === 20)
                                ?  
                                    <Grid item xs={1}>
                                        
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.horasEntradas.map((name) => {
                                    if(this.state.datoEspecifico.entrada === name.idEntrada){
                                        entradaIn = name.descripcion;
                                }})}
                                {this.state.horasEntradas.map((name) => {
                                    if(this.state.datoEspecifico.salida === name.idEntrada){
                                        salidaIn = name.descripcion;
                                }})}
                                {this.state.datoEspecifico.codigo === 71
                                ?
                                    <Grid item xs={2}>
                                        <Item>Entrada</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 52
                                ?
                                    <Grid item xs={2}>
                                        <Item>Asignatura</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 10
                                ?
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 10
                                ?
                                    <Grid item xs={2}>
                                        <Item>Nueva Dirección</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 52 || this.state.datoEspecifico.codigo === 10
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.juzgado}
                                    </Grid>
                                :
                                    null
                                }
                                {(this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 52) && (this.state.datoEspecifico.finalizado === 12)
                                ?
                                    <Grid item xs={2}>

                                    </Grid>
                                :
                                    null
                                }
                                {(this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 52) && (this.state.datoEspecifico.finalizado === 12)
                                ?
                                    <Grid item xs={2}>
                                        <Item>Comprobante</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {(this.state.datoEspecifico.codigo === 5 || this.state.datoEspecifico.codigo === 52) && (this.state.datoEspecifico.finalizado === 12)
                                ?
                                    this.state.datoEspecifico.esPDF
                                    ?
                                        <Grid item xs={2}>
                                            <button className="btn btn-outline-primary mx-2" onClick={() => handleDownloadPdf('archivo.pdf', this.state.datoEspecifico.archivoBPS)}>Descargar</button>
                                        </Grid>
                                    :
                                        <Grid item xs={2}>
                                            <button className="btn btn-outline-danger mx-2" type='button' onClick={() => this.manejarModalImagen(this.state.datoEspecifico.archivoBPS)}>Ver</button>
                                        </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 71
                                ?
                                    <Grid item xs={2}>
                                        {entradaIn}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 71
                                ?
                                    <Grid item xs={1}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 71
                                ?
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 71
                                ?
                                    <Grid item xs={2}>
                                        <Item>Salida</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 71
                                ?
                                    <Grid item xs={2}>
                                        {salidaIn}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 71
                                ?
                                    <Grid item xs={1}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo !== 53 && this.state.datoEspecifico.codigo !== 30 && this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 3 && this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 62 && this.state.datoEspecifico.codigo !== 74 && this.state.datoEspecifico.codigo !== 71 && this.state.datoEspecifico.codigo !== 61 && this.state.datoEspecifico.codigo !== 14 && this.state.datoEspecifico.codigo !== 16 && this.state.datoEspecifico.codigo !== 17 && this.state.datoEspecifico.codigo !== 15 && this.state.datoEspecifico.codigo !== 4 && this.state.datoEspecifico.codigo !== 29 && this.state.datoEspecifico.codigo !== 46 && this.state.datoEspecifico.codigo !== 28 && this.state.datoEspecifico.codigo !== 42 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 77 && this.state.datoEspecifico.codigo !== 37 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 44 && this.state.datoEspecifico.codigo !== 51 && this.state.datoEspecifico.codigo !== 22 && this.state.datoEspecifico.codigo !== 23 && this.state.datoEspecifico.codigo !== 20 && this.state.datoEspecifico.codigo !== 57 && this.state.datoEspecifico.codigo !== 11 && this.state.datoEspecifico.codigo !== 12 && this.state.datoEspecifico.codigo !== 13 && this.state.datoEspecifico.codigo !== 35 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 107 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 108 && this.state.datoEspecifico.codigo !== 5 && this.state.datoEspecifico.codigo !== 52 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 47 && this.state.datoEspecifico.codigo !== 48 && this.state.datoEspecifico.codigo !== 56 && this.state.datoEspecifico.codigo !== 66
                                ?    
                                    <Grid item xs={2}>
                                        <Item>Ejercicio (AÑO)</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo !== 53 && this.state.datoEspecifico.codigo !== 30 && this.state.datoEspecifico.codigo !== 60 && this.state.datoEspecifico.codigo !== 3 && this.state.datoEspecifico.codigo !== 75 && this.state.datoEspecifico.codigo !== 62 && this.state.datoEspecifico.codigo !== 74 && this.state.datoEspecifico.codigo !== 71 && this.state.datoEspecifico.codigo !== 61 && this.state.datoEspecifico.codigo !== 14 && this.state.datoEspecifico.codigo !== 16 && this.state.datoEspecifico.codigo !== 17 && this.state.datoEspecifico.codigo !== 15 && this.state.datoEspecifico.codigo !== 4 && this.state.datoEspecifico.codigo !== 29 && this.state.datoEspecifico.codigo !== 46 && this.state.datoEspecifico.codigo !== 28 && this.state.datoEspecifico.codigo !== 42 && this.state.datoEspecifico.codigo !== 43 && this.state.datoEspecifico.codigo !== 77 && this.state.datoEspecifico.codigo !== 37 && this.state.datoEspecifico.codigo !== 19 && this.state.datoEspecifico.codigo !== 10 && this.state.datoEspecifico.codigo !== 21 && this.state.datoEspecifico.codigo !== 44 && this.state.datoEspecifico.codigo !== 51 && this.state.datoEspecifico.codigo !== 22 && this.state.datoEspecifico.codigo !== 23 && this.state.datoEspecifico.codigo !== 20 && this.state.datoEspecifico.codigo !== 57 && this.state.datoEspecifico.codigo !== 11 && this.state.datoEspecifico.codigo !== 12 && this.state.datoEspecifico.codigo !== 13 && this.state.datoEspecifico.codigo !== 35 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 107 && this.state.datoEspecifico.codigo !== 109 && this.state.datoEspecifico.codigo !== 108 && this.state.datoEspecifico.codigo !== 5 && this.state.datoEspecifico.codigo !== 52 && this.state.datoEspecifico.codigo !== 110 && this.state.datoEspecifico.codigo !== 47 && this.state.datoEspecifico.codigo !== 48 && this.state.datoEspecifico.codigo !== 56 && this.state.datoEspecifico.codigo !== 66
                                ?  
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.anio}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 2 && this.state.datoEspecifico.codigo !== 106 && this.state.datoEspecifico.codigo !== 109
                                ?  
                                    <Grid item xs={1}>
                                        
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46
                                ?
                                    <Grid item xs={2}>

                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 77 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 106 || this.state.datoEspecifico.codigo === 109 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46 || this.state.datoEspecifico.codigo === 110
                                ?    
                                    <Grid item xs={2}>
                                        <Item>Minutos</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 110 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 77 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 106 || this.state.datoEspecifico.codigo === 109 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46
                                ?  
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.minutos}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 110 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 77 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46
                                ?  
                                    <Grid item xs={1}>
                                        
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 35
                                ?    
                                    <Grid item xs={2}>
                                        <Item>Juzgado</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 35
                                ?  
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.juzgado}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 106 || this.state.datoEspecifico.codigo === 109
                                ?  
                                    <Grid item xs={1}>
                                        
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 77
                                ?
                                    <Grid item xs={2}>

                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 77 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46
                                ?    
                                    <Grid item xs={2}>
                                        <Item>Tipo Salida</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 30 || this.state.datoEspecifico.codigo === 60 || this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46 || this.state.datoEspecifico.codigo === 77 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 77
                                ?  
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.tipo}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 77
                                ?  
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 35 || this.state.datoEspecifico.codigo === 28 || this.state.datoEspecifico.codigo === 46
                                ?  
                                    <Grid item xs={1}>
                                        
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106
                                ?    
                                    <Grid item xs={2.1}>
                                        <Item>Entrada</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106
                                ?  
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106
                                ?  
                                    <Grid item xs={1}>
                                        
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106
                                ?    
                                    <Grid item xs={2.1}>
                                        <Item>Salilda</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106
                                ?  
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106
                                ?  
                                    <Grid item xs={1}>
                                        
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106
                                ?    
                                    <Grid item xs={2.1}>
                                        <Item>Entrada</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106
                                ?  
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106 || this.state.datoEspecifico.codigo === 109
                                ?  
                                    <Grid item xs={1}>
                                        
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 109
                                ?
                                    <Grid item xs={2.1}>
                                        <Item>Concepto</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 109
                                ?
                                    <Grid item xs={2.1}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 62
                                ?
                                    <Grid item xs={2}>
                                        <Item>Tipo Omisión</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 62
                                ?
                                    <Grid item xs={2}>
                                        {this.state.datoEspecifico.tipo}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106
                                ?    
                                    <Grid item xs={2.1}>
                                        <Item>Salilda</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106
                                ?  
                                    <Grid item xs={2}>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 106 || this.state.datoEspecifico.codigo === 109
                                ?  
                                    <Grid item xs={1}>
                                        
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 110
                                ?
                                    <Grid item xs={2}>
                                        <Item>Día</Item>
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 110
                                ?
                                    <Grid item xs={2}>
                                        {String(this.state.datoEspecifico.desde).substring(8,10) + '/' + String(this.state.datoEspecifico.desde).substring(5,7) + '/' + String(this.state.datoEspecifico.desde).substring(0,4)}
                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 110
                                ?
                                    <Grid item xs={1}>

                                    </Grid>
                                :
                                    null
                                }
                                {this.state.datoEspecifico.codigo === 74
                                ?
                                    <TableContainer style={{width: '100%', marginLeft:'auto', marginRight:'auto'}} component={Paper}>
                                        <Table sx={{minWidth: 700}}>
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell>Lunes</StyledTableCell>
                                                    <StyledTableCell>Martes</StyledTableCell>
                                                    <StyledTableCell>Miercoles</StyledTableCell>
                                                    <StyledTableCell>Jueves</StyledTableCell>
                                                    <StyledTableCell>Viernes</StyledTableCell>
                                                    <StyledTableCell>Sábado</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                <StyledTableRow>
                                                    {this.state.horasEntradas.map((name) => {
                                                        if(this.state.datoEspecifico.entradaLunes === name.idEntrada){
                                                            entradaIn = name.descripcion;
                                                    }})}
                                                    <StyledTableCell>{entradaIn}</StyledTableCell>
                                                    {this.state.horasEntradas.map((name) => {
                                                        if(this.state.datoEspecifico.entradaMartes === name.idEntrada){
                                                            entradaIn = name.descripcion;
                                                    }})}
                                                    <StyledTableCell>{entradaIn}</StyledTableCell>
                                                    {this.state.horasEntradas.map((name) => {
                                                        if(this.state.datoEspecifico.entradaMiercoles === name.idEntrada){
                                                            entradaIn = name.descripcion;
                                                    }})}
                                                    <StyledTableCell>{entradaIn}</StyledTableCell>
                                                    {this.state.horasEntradas.map((name) => {
                                                        if(this.state.datoEspecifico.entradaJueves === name.idEntrada){
                                                            entradaIn = name.descripcion;
                                                    }})}
                                                    <StyledTableCell>{entradaIn}</StyledTableCell>
                                                    {this.state.horasEntradas.map((name) => {
                                                        if(this.state.datoEspecifico.entradaViernes === name.idEntrada){
                                                            entradaIn = name.descripcion;
                                                    }})}
                                                    <StyledTableCell>{entradaIn}</StyledTableCell>
                                                    {this.state.horasEntradas.map((name) => {
                                                        if(this.state.datoEspecifico.entradaSabado === name.idEntrada){
                                                            entradaIn = name.descripcion;
                                                    }})}
                                                    <StyledTableCell>{entradaIn}</StyledTableCell>
                                                </StyledTableRow>
                                                <StyledTableRow>
                                                    {this.state.horasEntradas.map((name) => {
                                                        if(this.state.datoEspecifico.salidaLunes === name.idEntrada){
                                                            entradaIn = name.descripcion;
                                                    }})}
                                                    <StyledTableCell>{entradaIn}</StyledTableCell>
                                                    {this.state.horasEntradas.map((name) => {
                                                        if(this.state.datoEspecifico.salidaMartes === name.idEntrada){
                                                            entradaIn = name.descripcion;
                                                    }})}
                                                    <StyledTableCell>{entradaIn}</StyledTableCell>
                                                    {this.state.horasEntradas.map((name) => {
                                                        if(this.state.datoEspecifico.salidaMiercoles === name.idEntrada){
                                                            entradaIn = name.descripcion;
                                                    }})}
                                                    <StyledTableCell>{entradaIn}</StyledTableCell>
                                                    {this.state.horasEntradas.map((name) => {
                                                        if(this.state.datoEspecifico.salidaJueves === name.idEntrada){
                                                            entradaIn = name.descripcion;
                                                    }})}
                                                    <StyledTableCell>{entradaIn}</StyledTableCell>
                                                    {this.state.horasEntradas.map((name) => {
                                                        if(this.state.datoEspecifico.salidaViernes === name.idEntrada){
                                                            entradaIn = name.descripcion;
                                                    }})}
                                                    <StyledTableCell>{entradaIn}</StyledTableCell>
                                                    {this.state.horasEntradas.map((name) => {
                                                        if(this.state.datoEspecifico.salidaSabado === name.idEntrada){
                                                            entradaIn = name.descripcion;
                                                    }})}
                                                    <StyledTableCell>{entradaIn}</StyledTableCell>
                                                </StyledTableRow>
                                                <StyledTableRow>
                                                    <StyledTableCell></StyledTableCell>
                                                    <StyledTableCell></StyledTableCell>
                                                    <StyledTableCell>Desde</StyledTableCell>
                                                    <StyledTableCell>{String(this.state.datoEspecifico.desde).substring(8,10) + '/' + String(this.state.datoEspecifico.desde).substring(5,7) + '/' + String(this.state.datoEspecifico.desde).substring(0,4)}</StyledTableCell>
                                                    <StyledTableCell></StyledTableCell>
                                                    <StyledTableCell></StyledTableCell>
                                                </StyledTableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                :
                                    null
                                }
                            </Grid>
                        </Box>
                        {this.state.datoEspecifico.codigo === 110 || this.state.datoEspecifico.codigo === 60
                        ?
                            <br/>
                        :
                            null
                        }
                        {this.state.datoEspecifico.codigo === 110 || this.state.datoEspecifico.codigo === 61 || this.state.datoEspecifico.codigo === 37 || this.state.datoEspecifico.codigo === 77 || this.state.datoEspecifico.codigo === 60 ? <textarea style={{width:"100%", border:"2px solid #D6EAF8"}} rows={5} cols={20} id='comentarios' value={this.state.datoEspecifico.comentarios} disabled/> : null}
                        <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtrasEspecifica}>Volver</button>
                    </Container>
                :
                    null
                }
                {/*sessionStorage.login  && (sessionStorage.tipoUsuario === '4' || sessionStorage.tipoUsuario === '5' || sessionStorage.tipoUsuario === '6')
                ?
                    this.state.reglamentariaPDF
                    ?
                        <PDFDownloadLink document={<InformesReglamentaria datoFun={this.state.datoPDF}/>} fileName='documento.pdf'>
                            <Button>Descargar PDF Reglamentaria</Button>
                        </PDFDownloadLink>
                    :
                        this.state.enfermedadPDF
                        ?
                            <PDFDownloadLink document={<InformesEnfermedad datoFun={this.state.datoPDF}/>} fileName='documento.pdf'>
                                <Button>Descargar PDF Enfermedad</Button>
                            </PDFDownloadLink>
                        :
                            this.state.complementoPDF
                            ?
                                <PDFDownloadLink document={<ComplementoAntiguedad datoFun={this.state.datoPDF}/>} fileName='documento.pdf'>
                                    <Button>Descargar PDF Enfermedad</Button>
                                </PDFDownloadLink>
                            :
                                this.state.general
                                ?
                                    <PDFDownloadLink document={<GeneralPDF datoFun={this.state.datoPDF}/>} fileName='documento.pdf'>
                                        <Button>Descargar PDF</Button>
                                    </PDFDownloadLink>
                                :
                                    null
                :
                    <Redirect to='/login'/>
            */}

                {this.state.imagenMostrarModal
                ?
                    <Modal open={this.state.imagenMostrarModal}>
                        <Box sx={styleModal} >
                            <Grid container spacing={2} rowSpacing={1}>
                                <img src={this.state.imagenMostrar} alt="" style={{ width: '90%'}}/>
                                <Grid item xs={5}>
                                    
                                </Grid>
                                <Grid item xs={2}>
                                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarCerrarModal}>Cerrar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    </Modal>
                :
                    null
                }
            </>
        )//Final return
    }//Final render

    manejarAtras(e){
        e.preventDefault();
        this.setState({
            consulta: false,
            reglamentariaPDF: false,
            enfermedadPDF: false,
            complementoPDF: false,
            general: false,
            errores: null,
            notificaciones: null,
            datoModal: {
                numeroFuncionario: '',
                nombreFuncionario: '',
                motivoRechazo: '',
                tipoUsuario: sessionStorage.tipoUsuario,
            },

            busqueda: {
                informe: '',
                numeroFuncionarioBusqueda: '',
                nombreFuncionarioBusqueda: '',
                ubicacionBusqueda: '',
                ubicacionCentral: '',
                desdeBusqueda: '',
                hastaBusqueda: '',
                tipoUsuario: sessionStorage.tipoUsuario,
                anio: '',
                dias: '',
                minutos: '',
                salida: '',
                entrada: '',
            }
        })
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState({
            errores: null,
            notificaciones: null,
            reglamentariaPDF: false,
            enfermedadPDF: false,
            complementoPDF: false,
        });
        this.setState(state => {
            const numFunActualizado = state.busqueda;
            numFunActualizado[clave] = valor;
            
            if(clave === 'numeroFuncionarioBusqueda'){
                //valor = parseFloat(valor);
                //Tengo que buscar la informacion de ese funcionario
                let aux = true;
                this.state.numeroNombre.map((name) =>
                {if(name.numeroFuncionario === valor){
                    numFunActualizado['nombreFuncionarioBusqueda'] = name.primerNombre + ' ' + name.primerApellido;
                    aux = false;
                }else if(aux){
                    numFunActualizado['nombreFuncionarioBusqueda'] = '';
                }
                });
            }
            
            return{
                busqueda: numFunActualizado,
            };
        });
    }

    manejarRechazar(dato){
        //Si lo rechazo le cambio el estado para que le aparezca al funcionario indicando el motivo
        this.setState({
            modalRechazar: true,
            datoModal: dato,
        })
    }

    manejarCambioRechazo(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const movEditarActualizado = state.datoModal;

            movEditarActualizado[clave] = valor;
            return {
                datoModal: movEditarActualizado,
            }
        })
    }

    async manejarEnvioRechazo(e){
        e.preventDefault();
        if(this.state.datoModal.motivoRechazo === ''){
            this.setState({
                errores: 'Debe ingresar el motivo del rechazo',
                modalRechazar: false,
            })
        }else if((this.state.datoModal.codigo === 5) || (this.state.datoModal.codigo === 52)){
            const cargaUtil = JSON.stringify([this.state.datoModal, sessionStorage.tipoUsuario, this.state.archivo, sessionStorage.numeroFuncionarioAsociado]);

            const res = await fetch(`${Constantes.RUTA_API}/actualizar_informeComprobanteRechazar.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await res.json()
            if(exito){
                //this.actList();
                this.setState(prevState => ({
                    datosConsulta: prevState.datosConsulta.filter(item => item.idInformes !== this.state.datoModal.idInformes)
                }));
                this.setState({
                    notificaciones: 'El informe fue actualizado correctamente!',
                    modalRechazar: false,
                })
            }
        }else{
            const cargaUtil = JSON.stringify([this.state.datoModal, sessionStorage.tipoUsuario, this.state.archivo, sessionStorage.numeroFuncionarioAsociado]);

            const res = await fetch(`${Constantes.RUTA_API}/actualizar_informe.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await res.json()
            if(exito){
                //this.actList();
                this.setState(prevState => ({
                    datosConsulta: prevState.datosConsulta.filter(item => item.idInformes !== this.state.datoModal.idInformes)
                }));
                this.setState({
                    notificaciones: 'El informe fue actualizado correctamente!',
                    modalRechazar: false,
                })
            }
        }
    }


    async actList(e){
        const cargaUtil = JSON.stringify(this.state.busqueda);

        const infoSol = await fetch(`${Constantes.RUTA_API}/obtener_informes.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const datosInfoSol = await infoSol.json();
        
        if(datosInfoSol[0] === 'ok'){
            this.setState({
                datosConsulta: datosInfoSol[1],
                consulta: true,
            });
        }
    }

    manejarCambiosDatosArchivo(e){
        e.preventDefault();
        const clave = e.target.id;
        let valor = e.target.files[0];
        const reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        if(clave === 'archivo'){
            reader.onload = (e) => {
                e.preventDefault();
                this.setState({
                    archivo: e.target.result,
                    errores: null,
                    notificaciones: null,
                })
            };
        }else if(clave === 'archivoActa'){
            reader.onload = (e) => {
                e.preventDefault();
                this.setState({
                    archivoActa: e.target.result,
                    errores: null,
                    notificaciones: null,
                })
            };
        }
    }

    async manejarAceptar(dato){
        
        //Si lo acepta le cambio el estado al informe para que pase a RRHH
        this.setState({
            loading: true,
        })
        if((sessionStorage.tipoUsuario !== '4')){
            const cargaUtil = JSON.stringify([dato, sessionStorage.tipoUsuario, this.state.archivo, sessionStorage.numeroFuncionarioAsociado]);

            const res = await fetch(`${Constantes.RUTA_API}/actualizar_informe.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await res.json()
            this.setState({
                loading: false,
            })
            if(exito){
                /*let texto = 'Probando está cosa\nVamo Nacional';
                const blob = new Blob([texto], {type: 'text/plain;charset=utf-8'});
                saveAs(blob, 'prueba.doc');*/
                //this.actList();
                this.setState(prevState => ({
                    datosConsulta: prevState.datosConsulta.filter(item => item.idInformes !== dato.idInformes)
                }));
                this.setState({
                    modalRechazar: false,
                })
                if((exito.length != 0) && (sessionStorage.tipoUsuario === '5')){
                    //----------------------------------------------------
                    //Voy a probar ingresar automaticamente el movimiento
                    
                    //----------------------------------------------------
                    this.setState({
                        notificaciones: 'El informe fue actualizado correctamente!',
                        modalRechazar: false,
                        datoPDF: exito[0],
                    })
                    if((exito[0].codigo === 1)){
                        if(exito[0].complemento){
                            this.setState({
                                reglamentariaPDF: false,
                                enfermedadPDF: false,
                                complementoPDF: true,
                                general: false,
                            })
                        }else{
                            this.setState({
                                reglamentariaPDF: true,
                                enfermedadPDF: false,
                                complementoPDF: false,
                                general: false,
                            })
                        }
                        
                    }else if((exito[0].codigo === 2)){
                        this.setState({
                            reglamentariaPDF: true,
                            enfermedadPDF: false,
                            complementoPDF: false,
                            general: false,
                        })
                        
                    }else if(exito[0].codigo === 3){
                        this.setState({
                            enfermedadPDF: true,
                            reglamentariaPDF: false,
                            complementoPDF: false,
                            general: false,
                        })
                    }else if((exito[0].codigo === 4) || (exito[0].codigo === 5) || (exito[0].codigo === 52) || (exito[0].codigo === 40) || (exito[0].codigo === 42) || (exito[0].codigo === 43) || (exito[0].codigo === 37) || (exito[0].codigo === 19) || (exito[0].codigo === 10) 
                    || (exito[0].codigo === 49) || (exito[0].codigo === 21) || (exito[0].codigo === 44) || (exito[0].codigo === 51) || (exito[0].codigo === 22) || (exito[0].codigo === 23) || (exito[0].codigo === 20) || (exito[0].codigo === 29) || (exito[0].codigo === 53) || (exito[0].codigo === 57) || (exito[0].codigo === 16)
                    || (exito[0].codigo === 17) || (exito[0].codigo === 7) || (exito[0].codigo === 8)|| (exito[0].codigo === 11) || (exito[0].codigo === 12) || (exito[0].codigo === 13) || (exito[0].codigo === 35) || (exito[0].codigo === 106) || (exito[0].codigo === 107) || (exito[0].codigo === 108) || (exito[0].codigo === 109)){
                        this.setState({
                            enfermedadPDF: false,
                            reglamentariaPDF: false,
                            complementoPDF: false,
                            general: true,
                        })
                    }
                }else if(sessionStorage.tipoUsuario === '4'){
                    //--------------------------------------------------------
                    /*this.setState({
                        movimientos: {
                            numeroFuncionario: dato.numeroFuncionario,
                            codigo: dato.codigo,
                            nombreFuncionario: dato.nombreFuncionario,
                            dias: dato.dias,
                            minutos: dato.minutos,
                            desde: dato.desde,
                            hasta: dato.hasta,
                            anio: dato.anio,
                            tipoMov: '1',
                            tipoHS: dato.tipo,
                            tipoConsulta: dato.tipo,
                        }
                    })*/
                    const cargaUtil = JSON.stringify([dato,1]);
                    //Voy a probar hacer los controles en la logica

                    const control = await fetch(`${Constantes.RUTA_API}/contrlar_movimiento.php`,{
                        method: 'POST',
                        body: cargaUtil,
                    })
                    const res = await control.json();
                    this.setState({
                        errores: res,
                        notificaciones: null,
                    });
                    if(res === 'ok'){
                        this.setState({
                            notificaciones: 'El informe fue actualizado y el movimiento fue ingresado correctamente!',
                            modalRechazar: false,
                            errores: false,
                            movimientos: exito[0],
                        })
                    }
                    //--------------------------------------------------------
                    /*this.setState({
                        notificaciones: 'El informe fue actualizado y el movimiento fue ingresado correctamente!',
                        modalRechazar: false,
                        errores: false,
                        movimientos: exito[0],
                    })*/
                }else if(sessionStorage.tipoUsuario === '6'){
                    this.setState({
                        notificaciones: 'El informe fue actualizado correctamente!',
                        modalRechazar: false,
                        errores: false,
                        movimientos: exito[0],
                        //datosConsulta: [],
                    })
                }
            }
        }else if((sessionStorage.tipoUsuario === '4') && (((dato.codigo === 5) || (dato.codigo === 52)) && (dato.finalizado === 12))){
            const cargaUtil = JSON.stringify([dato, sessionStorage.tipoUsuario, this.state.archivo, sessionStorage.numeroFuncionarioAsociado]);

            const res = await fetch(`${Constantes.RUTA_API}/actualizar_informeComprobante.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await res.json()
            this.setState({
                notificaciones: 'El informe fue actualizado correctamente!',
                modalRechazar: false,
                errores: false,
                movimientos: exito[0],
                loading: false,
            })
            //this.actList();
            this.setState(prevState => ({
                datosConsulta: prevState.datosConsulta.filter(item => item.idInformes !== dato.idInformes)
            }));
        }else if((sessionStorage.tipoUsuario === '4')){
            const cargaUtil = JSON.stringify([dato,1]);
            //Voy a probar hacer los controles en la logica

            const control = await fetch(`${Constantes.RUTA_API}/contrlar_movimiento.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const res = await control.json();
            this.setState({
                errores: res,
                notificaciones: null,
                loading: false,
            });
            
            if(res === 'ok'){
                this.setState({
                    modalRechazar: false,
                    loading: true,
                    errores: null,
                    notificaciones: null,
                })
                const cargaUtil = JSON.stringify([dato, sessionStorage.tipoUsuario, this.state.archivo, sessionStorage.numeroFuncionarioAsociado]);

                const res = await fetch(`${Constantes.RUTA_API}/actualizar_informe.php`,{
                    method: 'POST',
                    body: cargaUtil,
                })
                const exito = await res.json()
                this.setState({
                    notificaciones: 'El informe fue actualizado y el movimiento fue ingresado correctamente!',
                    modalRechazar: false,
                    errores: false,
                    movimientos: exito[0],
                    loading: false,
                })
                this.setState(prevState => ({
                    datosConsulta: prevState.datosConsulta.filter(item => item.idInformes !== dato.idInformes)
                }));
                //this.actList();
            }
        }
    }

    cerrarModal(e){
        e.preventDefault();
        this.setState({
            modalRechazar: false,
        })
    }

    manejarCambiosContinua(e){
        if(this.state.continua){
            this.setState({
                continua: false,
            })
        }else{
            this.setState({
                continua: true,
            })
        }
    }

    async manejoEnvioConsulta(){
        this.setState({
            errores: null,
            notificaciones: null,
        });
        
        if((this.state.busqueda.informe === '')){
            this.setState({
                errores: 'DEBE SELECCIONAR UN TIPO DE INFORME',
                notificaciones: null,
            });
        }else if((sessionStorage.tipoUsuario === '4') && ((this.state.busqueda.informe === '3') || (this.state.busqueda.informe === '16') || (this.state.busqueda.informe === '17') || (this.state.busqueda.informe === '7') || (this.state.busqueda.informe === '8')) && (this.state.busqueda.numeroFuncionarioBusqueda === '')){
            this.setState({
                notificaciones: null,
                errores: 'DEBE INGRESAR UN NUMERO DE FUNCIONARIO!',
            })
        }else if((sessionStorage.tipoUsuario === '4') && ((this.state.busqueda.informe === '3') || (this.state.busqueda.informe === '16') || (this.state.busqueda.informe === '17') || (this.state.busqueda.informe === '7') || (this.state.busqueda.informe === '8')) && ((this.state.busqueda.numeroFuncionarioBusqueda !== '') && (this.state.busqueda.nombreFuncionarioBusqueda === ''))){
            this.setState({
                notificaciones: null,
                errores: 'DEBE INGRESAR UN NUMERO DE FUNCIONARIO VALIDO!',
            })
        }else if((sessionStorage.tipoUsuario === '4') && ((this.state.busqueda.informe === '16') || (this.state.busqueda.informe === '17') || (this.state.busqueda.informe === '8')) && (this.state.busqueda.dias === '')){
            this.setState({
                notificaciones: null,
                errores: 'DEBE INGRESAR LA CANTIDAD DE DIAS!',
            })
        }else if((sessionStorage.tipoUsuario === '4') && ((this.state.busqueda.informe === '3') || (this.state.busqueda.informe === '16') || (this.state.busqueda.informe === '17') || (this.state.busqueda.informe === '7') || (this.state.busqueda.informe === '8')) && (this.state.busqueda.desdeBusqueda === '')){
            this.setState({
                notificaciones: null,
                errores: 'DEBE INGRESAR LA FECHA DESDE!',
            })
        }else if((sessionStorage.tipoUsuario === '4') && ((this.state.busqueda.informe === '3') || (this.state.busqueda.informe === '16') || (this.state.busqueda.informe === '17') || (this.state.busqueda.informe === '7')) && (this.state.busqueda.hastaBusqueda === '')){
            this.setState({
                notificaciones: null,
                errores: 'DEBE INGRESAR LA FECHA HASTA!',
            })
        }else if((sessionStorage.tipoUsuario === '4') && ((this.state.busqueda.informe === '7') || (this.state.busqueda.informe === '8')) && (this.state.archivo === '')){
            this.setState({
                notificaciones: null,
                errores: 'DEBE SELECCIONAR LA IMAGEN DE BPS!',
            })
        }else if((sessionStorage.tipoUsuario === '4') && ((this.state.archivo === '') && (this.state.busqueda.informe === '3') && (!this.state.continua))){
            this.setState({
                notificaciones: null,
                errores: 'DEBE SELECCIONAR LA IMAGEN DE BPS!',
            })
        }else if((sessionStorage.tipoUsuario === '4') && ((this.state.busqueda.informe === '3') && (this.state.busqueda.desdeBusqueda.substring(0,4) !== this.state.busqueda.hastaBusqueda.substring(0,4)))){
            this.setState({
                notificaciones: null,
                errores: 'EL AÑO DE INICIO DEBE SER IGUAL AL AÑO DE FIN!',
            })
        }else if((sessionStorage.tipoUsuario === '4') && ((this.state.busqueda.informe === '8')) && (this.state.archivoActa === '')){
            this.setState({
                notificaciones: null,
                errores: 'DEBE SELECCIONAR LA IMAGEN DE ACTA!',
            })
        }else{
            this.setState({
                loading: true,
            })
            let exito = []
            if((this.state.busqueda.informe === '110') || (this.state.busqueda.informe === '53') || (this.state.busqueda.informe === '30') || (this.state.busqueda.informe === '75') || (this.state.busqueda.informe === '1') || (this.state.busqueda.informe === '2') || (this.state.busqueda.informe === '4') || (this.state.busqueda.informe === '5') || (this.state.busqueda.informe === '52') || (this.state.busqueda.informe === '40') || (this.state.busqueda.informe === '42') || (this.state.busqueda.informe === '43')
             || (this.state.busqueda.informe === '37') || (this.state.busqueda.informe === '19') || (this.state.busqueda.informe === '10') || (this.state.busqueda.informe === '49') || (this.state.busqueda.informe === '21') || (this.state.busqueda.informe === '44') || (this.state.busqueda.informe === '51')
              || (this.state.busqueda.informe === '22') || (this.state.busqueda.informe === '23') || (this.state.busqueda.informe === '20') || (this.state.busqueda.informe === '29') || (this.state.busqueda.informe === '57') || (this.state.busqueda.informe === '11') || (this.state.busqueda.informe === '12')
              || (this.state.busqueda.informe === '13') || (this.state.busqueda.informe === '35') || (this.state.busqueda.informe === '106') || (this.state.busqueda.informe === '107') || (this.state.busqueda.informe === '108') || (this.state.busqueda.informe === '109') || (this.state.busqueda.informe === '10000')){
                const cargaUtil = JSON.stringify(this.state.busqueda);
                const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_informes.php`,{
                    method: 'POST',
                    body: cargaUtil,
                })
                exito = await respuesta.json();
                this.setState({
                    loading: false,
                })
                if(exito[0] === 'ok'){
                    const fech = new Date();
                    this.setState({
                        datosConsulta: exito[1],
                        errores: null,
                        notificaciones: null,
                        consulta: true,
                    })
                }else{
                    this.setState({
                        //errores: 'No hay datos para la consulta realizada!',
                        errores: exito[0],
                        notificaciones: null,
                        consulta: false,
                    })
                }
            }else if(this.state.busqueda.informe === '3'){

                if(sessionStorage.tipoUsuario === '4'){
                    const cargaUtil = JSON.stringify([this.state.busqueda, this.state.archivo, sessionStorage.numeroFuncionarioAsociado]);
                    //Tengo que guardar el informe
                    const respuesta = await fetch(`${Constantes.RUTA_API}/guardar_informePersonal.php`,{
                        method: 'POST',
                        body: cargaUtil,
                    })
                    exito = await respuesta.json();
                    this.setState({
                        loading: false,
                    })
                    if(exito.length !== 0){
                        const fech = new Date();
                        this.setState({
                            errores: null,
                            notificaciones: 'El informe fue actualizado y el movimiento fue ingresado correctamente!',
                            archivo: '',
                            busqueda: {
                                informe: '',
                                numeroFuncionarioBusqueda: '',
                                nombreFuncionarioBusqueda: '',
                                ubicacionBusqueda: '',
                                ubicacionCentral: '',
                                desdeBusqueda: '',
                                hastaBusqueda: '',
                                tipoUsuario: sessionStorage.tipoUsuario,
                                anio: '',
                                dias: '',
                                minutos: '',
                                salida: '',
                                entrada: '',
                            },
                        })
                    }else{
                        this.setState({
                            errores: 'No hay datos para la consulta realizada!',
                            notificaciones: null,
                            consulta: false,
                        })
                    }
                }else{
                    const cargaUtil = JSON.stringify(this.state.busqueda);
                    const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_informes.php`,{
                        method: 'POST',
                        body: cargaUtil,
                    })
                    exito = await respuesta.json();
                    this.setState({
                        loading: false,
                    })
                    if(exito[0] === 'ok'){
                        const fech = new Date();
                        this.setState({
                            datosConsulta: exito[1],
                            errores: null,
                            notificaciones: null,
                            consulta: true,
                        })
                    }else{
                        this.setState({
                            errores: 'No hay datos para la consulta realizada!',
                            notificaciones: null,
                            consulta: false,
                        })
                    }
                }
            }/*else if(this.state.busqueda.informe === '53'){
                if(sessionStorage.tipoUsuario === '4'){
                    const cargaUtil = JSON.stringify([this.state.busqueda, this.state.archivo, sessionStorage.numeroFuncionarioAsociado]);
                    //Tengo que guardar el informe
                    const respuesta = await fetch(`${Constantes.RUTA_API}/guardar_informePersonal.php`,{
                        method: 'POST',
                        body: cargaUtil,
                    })
                    exito = await respuesta.json();
                    this.setState({
                        loading: false,
                    })
                    if(exito.length !== 0){
                        const fech = new Date();
                        this.setState({
                            errores: null,
                            notificaciones: 'El informe fue actualizado y el movimiento fue ingresado correctamente!',
                            archivo: '',
                            busqueda: {
                                informe: '',
                                numeroFuncionarioBusqueda: '',
                                nombreFuncionarioBusqueda: '',
                                ubicacionBusqueda: '',
                                ubicacionCentral: '',
                                desdeBusqueda: '',
                                hastaBusqueda: '',
                                tipoUsuario: sessionStorage.tipoUsuario,
                                anio: '',
                                dias: '',
                                minutos: '',
                                salida: '',
                                entrada: '',
                            },
                        })
                    }else{
                        this.setState({
                            errores: 'No hay datos para la consulta realizada!',
                            notificaciones: null,
                            consulta: false,
                        })
                    }

                }else{
                    const cargaUtil = JSON.stringify(this.state.busqueda);
                    const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_informes.php`,{
                        method: 'POST',
                        body: cargaUtil,
                    })
                    exito = await respuesta.json();
                    this.setState({
                        loading: false,
                    })
                    if(exito[0] === 0){
                        const fech = new Date();
                        this.setState({
                            datosConsulta: exito[1],
                            errores: null,
                            notificaciones: null,
                            consulta: true,
                        })
                    }else{
                        this.setState({
                            errores: 'No hay datos para la consulta realizada!',
                            notificaciones: null,
                            consulta: false,
                        })
                    }
                }
            }*/else if(this.state.busqueda.informe === '16'){
                if(sessionStorage.tipoUsuario === '4'){
                    const cargaUtil = JSON.stringify([this.state.busqueda, this.state.archivo, sessionStorage.numeroFuncionarioAsociado]);
                    //Tengo que guardar el informe
                    const respuesta = await fetch(`${Constantes.RUTA_API}/guardar_informePersonal.php`,{
                        method: 'POST',
                        body: cargaUtil,
                    })
                    exito = await respuesta.json();
                    this.setState({
                        loading: false,
                    })
                    if(exito.length !== 0){
                        const fech = new Date();
                        this.setState({
                            errores: null,
                            notificaciones: 'El informe fue actualizado y el movimiento fue ingresado correctamente!',
                            archivo: '',
                            busqueda: {
                                informe: '',
                                numeroFuncionarioBusqueda: '',
                                nombreFuncionarioBusqueda: '',
                                ubicacionBusqueda: '',
                                ubicacionCentral: '',
                                desdeBusqueda: '',
                                hastaBusqueda: '',
                                tipoUsuario: sessionStorage.tipoUsuario,
                                anio: '',
                                dias: '',
                                minutos: '',
                                salida: '',
                                entrada: '',
                            },
                        })
                    }else{
                        this.setState({
                            errores: 'No hay datos para la consulta realizada!',
                            notificaciones: null,
                            consulta: false,
                        })
                    }if(exito.length !== 0){
                        const fech = new Date();
                        this.setState({
                            errores: null,
                            notificaciones: 'El informe fue y el movimiento fuerron ingresados correctamente!',
                            archivo: '',
                            busqueda: {
                                informe: '',
                                numeroFuncionarioBusqueda: '',
                                nombreFuncionarioBusqueda: '',
                                ubicacionBusqueda: '',
                                ubicacionCentral: '',
                                desdeBusqueda: '',
                                hastaBusqueda: '',
                                tipoUsuario: sessionStorage.tipoUsuario,
                                anio: '',
                                dias: '',
                                minutos: '',
                                salida: '',
                                entrada: '',
                            },
                        })
                    }else{
                        this.setState({
                            errores: 'No hay datos para la consulta realizada!',
                            notificaciones: null,
                            consulta: false,
                        })
                    }
                }else{
                    const cargaUtil = JSON.stringify(this.state.busqueda);
                    const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_informes.php`,{
                        method: 'POST',
                        body: cargaUtil,
                    })
                    exito = await respuesta.json();
                    this.setState({
                        loading: false,
                    })
                    if(exito[0] === 'ok'){
                        const fech = new Date();
                        this.setState({
                            datosConsulta: exito[1],
                            errores: null,
                            notificaciones: null,
                            consulta: true,
                        })
                    }else{
                        this.setState({
                            errores: 'No hay datos para la consulta realizada!',
                            notificaciones: null,
                            consulta: false,
                        })
                    }
                }
            }else if(this.state.busqueda.informe === '17'){
                if(sessionStorage.tipoUsuario === '4'){
                    const cargaUtil = JSON.stringify([this.state.busqueda, this.state.archivo, sessionStorage.numeroFuncionarioAsociado]);
                    //Tengo que guardar el informe
                    const respuesta = await fetch(`${Constantes.RUTA_API}/guardar_informePersonal.php`,{
                        method: 'POST',
                        body: cargaUtil,
                    })
                    exito = await respuesta.json();
                    this.setState({
                        loading: false,
                    })
                    if(exito.length !== 0){
                        const fech = new Date();
                        this.setState({
                            errores: null,
                            notificaciones: 'El informe fue actualizado y el movimiento fue ingresado correctamente!',
                            archivo: '',
                            busqueda: {
                                informe: '',
                                numeroFuncionarioBusqueda: '',
                                nombreFuncionarioBusqueda: '',
                                ubicacionBusqueda: '',
                                ubicacionCentral: '',
                                desdeBusqueda: '',
                                hastaBusqueda: '',
                                tipoUsuario: sessionStorage.tipoUsuario,
                                anio: '',
                                dias: '',
                                minutos: '',
                                salida: '',
                                entrada: '',
                            },
                        })
                    }else{
                        this.setState({
                            errores: 'No hay datos para la consulta realizada!',
                            notificaciones: null,
                            consulta: false,
                        })
                    }if(exito.length !== 0){
                        const fech = new Date();
                        this.setState({
                            errores: null,
                            notificaciones: 'El informe fue y el movimiento fuerron ingresados correctamente!',
                            archivo: '',
                            busqueda: {
                                informe: '',
                                numeroFuncionarioBusqueda: '',
                                nombreFuncionarioBusqueda: '',
                                ubicacionBusqueda: '',
                                ubicacionCentral: '',
                                desdeBusqueda: '',
                                hastaBusqueda: '',
                                tipoUsuario: sessionStorage.tipoUsuario,
                                anio: '',
                                dias: '',
                                minutos: '',
                                salida: '',
                                entrada: '',
                            },
                        })
                    }else{
                        this.setState({
                            errores: 'No hay datos para la consulta realizada!',
                            notificaciones: null,
                            consulta: false,
                        })
                    }
                }else{
                    const cargaUtil = JSON.stringify(this.state.busqueda);
                    const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_informes.php`,{
                        method: 'POST',
                        body: cargaUtil,
                    })
                    exito = await respuesta.json();
                    this.setState({
                        loading: false,
                    })
                    if(exito[0] === 'ok'){
                        const fech = new Date();
                        this.setState({
                            datosConsulta: exito[1],
                            errores: null,
                            notificaciones: null,
                            consulta: true,
                        })
                    }else{
                        this.setState({
                            errores: 'No hay datos para la consulta realizada!',
                            notificaciones: null,
                            consulta: false,
                        })
                    }
                }
            }else if(this.state.busqueda.informe === '7'){
                if(sessionStorage.tipoUsuario === '4'){
                    const cargaUtil = JSON.stringify([this.state.busqueda, this.state.archivo, sessionStorage.numeroFuncionarioAsociado]);
                    //Tengo que guardar el informe
                    const respuesta = await fetch(`${Constantes.RUTA_API}/guardar_informePersonal.php`,{
                        method: 'POST',
                        body: cargaUtil,
                    })
                    exito = await respuesta.json();
                    this.setState({
                        loading: false,
                    })
                    if(exito.length !== 0){
                        const fech = new Date();
                        this.setState({
                            errores: null,
                            notificaciones: 'El informe fue actualizado y el movimiento fue ingresado correctamente!',
                            archivo: '',
                            busqueda: {
                                informe: '',
                                numeroFuncionarioBusqueda: '',
                                nombreFuncionarioBusqueda: '',
                                ubicacionBusqueda: '',
                                ubicacionCentral: '',
                                desdeBusqueda: '',
                                hastaBusqueda: '',
                                tipoUsuario: sessionStorage.tipoUsuario,
                                anio: '',
                                dias: '',
                                minutos: '',
                                salida: '',
                                entrada: '',
                            },
                        })
                    }else{
                        this.setState({
                            errores: 'No hay datos para la consulta realizada!',
                            notificaciones: null,
                            consulta: false,
                        })
                    }
                }else{
                    const cargaUtil = JSON.stringify(this.state.busqueda);
                    const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_informes.php`,{
                        method: 'POST',
                        body: cargaUtil,
                    })
                    exito = await respuesta.json();
                    this.setState({
                        loading: false,
                    })
                    if(exito[0] === 'ok'){
                        const fech = new Date();
                        this.setState({
                            datosConsulta: exito[1],
                            errores: null,
                            notificaciones: null,
                            consulta: true,
                        })
                    }else{
                        this.setState({
                            errores: 'No hay datos para la consulta realizada!',
                            notificaciones: null,
                            consulta: false,
                        })
                    }
                }
            }else if(this.state.busqueda.informe === '8'){
                if(sessionStorage.tipoUsuario === '4'){
                    const cargaUtil = JSON.stringify([this.state.busqueda, this.state.archivo, sessionStorage.numeroFuncionarioAsociado, this.state.archivoActa]);
                    //Tengo que guardar el informe
                    const respuesta = await fetch(`${Constantes.RUTA_API}/guardar_informePersonal.php`,{
                        method: 'POST',
                        body: cargaUtil,
                    })
                    exito = await respuesta.json();
                    this.setState({
                        loading: false,
                    })
                    if(exito.length !== 0){
                        const fech = new Date();
                        this.setState({
                            errores: null,
                            notificaciones: 'El informe fue actualizado y el movimiento fue ingresado correctamente!',
                            archivo: '',
                            busqueda: {
                                informe: '',
                                numeroFuncionarioBusqueda: '',
                                nombreFuncionarioBusqueda: '',
                                ubicacionBusqueda: '',
                                ubicacionCentral: '',
                                desdeBusqueda: '',
                                hastaBusqueda: '',
                                tipoUsuario: sessionStorage.tipoUsuario,
                                anio: '',
                                dias: '',
                                minutos: '',
                                salida: '',
                                entrada: '',
                            },
                        })
                    }else{
                        this.setState({
                            errores: 'No hay datos para la consulta realizada!',
                            notificaciones: null,
                            consulta: false,
                        })
                    }
                }else{
                    const cargaUtil = JSON.stringify(this.state.busqueda);
                    const respuesta = await fetch(`${Constantes.RUTA_API}/obtener_informes.php`,{
                        method: 'POST',
                        body: cargaUtil,
                    })
                    exito = await respuesta.json();
                    this.setState({
                        loading: false,
                    })
                    if(exito[0] === 'ok'){
                        const fech = new Date();
                        this.setState({
                            datosConsulta: exito[1],
                            errores: null,
                            notificaciones: null,
                            consulta: true,
                        })
                    }else{
                        this.setState({
                            errores: 'No hay datos para la consulta realizada!',
                            notificaciones: null,
                            consulta: false,
                        })
                    }
                }
            }
        }
    }

    manejarConsultaInforme(dato){
        this.setState({
            errores: null,
            notificaciones: null,
            consultaEspecifica: true,
            datoEspecifico: dato,
        })
    }

    manejarAtrasEspecifica(e){
        e.preventDefault();
        this.setState({
            reglamentariaPDF: false,
            enfermedadPDF: false,
            complementoPDF: false,
            general: false,
            errores: null,
            notificaciones: null,
            consultaEspecifica: false,
            datoEspecifico: {},
        })
    }
    
    manejarModalImagen(dato){
        this.setState({
            imagenMostrarModal: true,
            imagenMostrar: dato,
        })
    }

    manejarCerrarModal(e){
        e.preventDefault();
        this.setState({
            imagenMostrarModal: false,
            imagenMostrar: '',
        })
    }
}

export default Informes